module.exports = __webpack_public_path__ + "static/media/6.2.10551a22.zip";